// extracted by mini-css-extract-plugin
module.exports = {"userTipBlock":"UserTipText_userTipBlock__18F47","textTip":"UserTipText_textTip__2cIii","icon":"UserTipText_icon__3kF-N"};